import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';

export function bannerCardsFactory(PALETTE) {
    return {
        BannerCard: {
            eventCard: {
                clickableArea: {
                    stopClickEventPropagation: true,
                },
                container: {
                    style: {
                        minHeight: '100%',
                    },
                },
            },
            lightBannerCardDetails: {
                headlineText: {
                    style: {
                        ...PALETTE.CARD_BANNER_LIGHT_HEADER_TEXT,
                    },
                },
                primaryText: {
                    style: {
                        ...PALETTE.CARD_BANNER_LIGHT_MESSAGE_TEXT,
                    },
                },
                primaryButton: generatePrimaryButton(PALETTE.CARD_BANNER_LIGHT_PRIMARY_BUTTON),
                secondaryButton: generateSecondaryButton(PALETTE.CARD_BANNER_LIGHT_SECONDARY_BUTTON),
            },
            darkBannerCardDetails: {
                headlineText: {
                    style: {
                        ...PALETTE.CARD_BANNER_DARK_HEADER_TEXT,
                    },
                },
                primaryText: {
                    style: {
                        ...PALETTE.CARD_BANNER_DARK_MESSAGE_TEXT,
                    },
                },
                primaryButton: generatePrimaryButton(PALETTE.CARD_BANNER_DARK_PRIMARY_BUTTON),
                secondaryButton: generateSecondaryButton(PALETTE.CARD_BANNER_DARK_SECONDARY_BUTTON),
            },
        },
        BannerCardDetails: {
            secondaryTextWrapper: {
                style: {
                    ...resolveBackground(PALETTE.CARD_BANNER_INFO_SECTION_BG),
                },
            },
            secondaryText: {
                style: {
                    ...PALETTE.CARD_BANNER_INFO_TEXT,
                },
            },
        },
    };
}
